import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const AddUser = lazy(() => import('../../container/pages/AddUsers'));
const Projetcs = lazy(() => import('../../pages/projects/index'));

const PagesRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/edit-user/:id`} component={AddUser} />
      <Route path={`${path}`} component={Projetcs} />
    </Switch>
  );
};

export default PagesRoute;
